// src/components/RequestOrganiserForm.js
import React, { useState } from 'react';
import axios from 'axios';

export default function RequestOrganiserForm() {
  const [reason, setReason] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    try {
      await axios.post('http://localhost:5000/api/organisers/request', { reason });
      setMessage('✅ Request submitted');
      setReason('');
    } catch {
      setMessage('❌ Failed to send request');
    }
  };

  return (
    <div className="card">
      <h3>Request to Become an Organiser</h3>
      <form onSubmit={handleSubmit} className="form">
        <label>
          Reason:
          <textarea value={reason} onChange={(e) => setReason(e.target.value)} required />
        </label>
        <button type="submit">Submit Request</button>
        {message && <p>{message}</p>}
      </form>
    </div>
  );
}
